type File6IconProps = {
  color?: string;
  size?: string;
}

export const File6Icon = ({ size, color }: File6IconProps): JSX.Element => (
  <svg width={size ?? '14'} height={size ?? '15'} viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_5683_9946)">
      <path d="M8.16732 1.82389V4.23338C8.16732 4.56007 8.16732 4.72342 8.2309 4.8482C8.28682 4.95797 8.37606 5.0472 8.48582 5.10313C8.61061 5.16671 8.77395 5.16671 9.10065 5.16671H11.5101M9.33398 8.08333H4.66732M9.33398 10.4167H4.66732M5.83398 5.75H4.66732M8.16732 1.66667H5.13398C4.15389 1.66667 3.66385 1.66667 3.2895 1.85741C2.96022 2.02518 2.6925 2.2929 2.52472 2.62218C2.33398 2.99653 2.33398 3.48658 2.33398 4.46667V10.5333C2.33398 11.5134 2.33398 12.0035 2.52472 12.3778C2.6925 12.7071 2.96022 12.9748 3.2895 13.1426C3.66385 13.3333 4.15389 13.3333 5.13398 13.3333H8.86732C9.84741 13.3333 10.3375 13.3333 10.7118 13.1426C11.0411 12.9748 11.3088 12.7071 11.4766 12.3778C11.6673 12.0035 11.6673 11.5134 11.6673 10.5333V5.16667L8.16732 1.66667Z" stroke={color ?? '#363BC4'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_5683_9946">
        <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>

);
